import { render, staticRenderFns } from "./social-networks.vue?vue&type=template&id=68cc370a&lang=pug&"
import script from "./social-networks.vue?vue&type=script&lang=js&"
export * from "./social-networks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports